<template>
  <div>
    <div>
      <div style="display: flex">
        <span class="mr-5">
          <b-button variant="outline-primary" size="sm" @click="modal = !modal"
            >Select</b-button
          >
        </span>

        <span class="mr-3"
          >{{ selectedValuesPreview.length }} codes had been selected</span
        >
      </div>
    </div>
    <b-modal v-model="modal" :title="filter.levelCaption" ok-only>
      <b-row>
        <b-col cols="12" class="m-2 pr-5">
          <b-alert show variant="warning">
            Please select a brand.
            <br />Brand must be selected to use the Member Code filter.
          </b-alert>
        </b-col>
        <b-col cols="12" class="mb-5 pr-5 pl-4">
          <treeselect
            v-model="brand"
            :options="options"
            :clearable="false"
          ></treeselect>
        </b-col>
        <b-col cols="12" class="m-2 mb-3">
          <small
            >Upload excel file with the values written to the first column;
            without the header.</small
          >
        </b-col>
        <b-col cols="12">
          <b-form-file
            size="sm"
            v-model="file"
            placeholder="Upload file here..."
            drop-placeholder="Drop file here..."
            accept=".xlsx, .xls"
          ></b-form-file>
        </b-col>
        <b-col cols="12" class="m-2 mb-3">
          <small>or type them directly as comma separated string</small>
        </b-col>
        <b-col cols="12">
          <b-input
            size="sm"
            type="text"
            placeholder="e.g.   username1,username2,username3"
            v-model="csv"
            @focus="
              $event.target.setSelectionRange(0, $event.target.value.length)
            "
          />
        </b-col>
        <b-col cols="12" v-if="selectedValuesPreview.length > 0">
          <div class="my-2">
            <small class="text-primary"
              >{{ selectedValuesPreview.length }} codes had been selected</small
            >
          </div>
          <div class="ml-2">
            <div>Samples:</div>
            <div
              v-for="(item, index) in selectedValuesPreview.slice(0, 10)"
              :key="index"
            >
              <small>{{ item }}</small>
            </div>
            <div v-if="selectedValuesPreview.length > 10">
              <small>...</small>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import _ from 'lodash';
import XLSX from 'xlsx';
import http from '@/mixins/http';

export default {
  name: 'FilterMemberCode',
  props: {
    filter: {
      type: Object,
      required: true,
    },
    selectedCubeId: {
      type: Number,
      required: true,
    },
  },
  mixins: [http],
  mounted() {
    this.getBrands();

    this.processSavedFilter();
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.processSavedFilter();
      },
    },
    brand: {
      deep: true,
      handler() {
        if (this.brand) {
          let list = this.csv.replace(/[^0-9a-z,]/gi, '').split(',');
          list = _.chain(list)
            .filter(item => {
              return item; //remove empty item
            })
            .uniq()
            .map(item => {
              return (
                this.filter.level.levelId +
                '.&[' +
                this.brandCode +
                '.' +
                item +
                ']'
              );
            })
            .value();
          this.selectedValues = list;
          this.changed(this.selectedValues);
        }
      },
    },
    csv: {
      deep: true,
      handler() {
        let list = this.csv.replace(/[^0-9a-z,]/gi, '').split(',');
        list = _.chain(list)
          .filter(item => {
            return item; //remove empty item
          })
          .uniq()
          .map(item => {
            return (
              this.filter.level.levelId +
              '.&[' +
              this.brandCode +
              '.' +
              item +
              ']'
            );
          })
          .value();
        this.selectedValues = list;
        this.changed(this.selectedValues);
      },
    },
  },
  computed: {
    selectedValuesPreview() {
      let list = this.csv.replace(/[^0-9a-z,]/gi, '').split(',');
      list = _.chain(list)
        .map(item => {
          return item.substring(0, 50); //control name that is too long (not supposed to be)
        })
        .uniq()
        .filter(item => {
          return item; //remove empty item
        })
        .value();
      return list;
    },
    brandCode() {
      //temporary use this to handle unique code
      const brand = this.brand;
      switch (brand) {
        case 'F1':
          return 'fun88';
        case 'T1':
          return 'tlc88';
        case 'R1':
          return 'rb88';
        case 'P1':
          return 'betway';
        case 'J1':
          return 'jbo';
        case 'B1MX':
          return 'B1MX';
        case 'F1M5':
          return 'F1M5';
        default:
          return brand;
      }
    },
    options() {
      return _.map(this.brands, function(v) {
        return { id: v.name, label: v.name };
      });
    },
    list() {
      return _.map(this.selectedValuesPreview, row => {
        return (
          this.filter.level.levelId + '.&[' + this.brandCode + '.' + row + ']'
        );
      });
    },
  },

  data() {
    return {
      isLoading: false,
      selectedValues: [],
      values: [],
      brand: null,
      brands: [],

      modal: false,
      file: null,
      csv: '',
    };
  },
  methods: {
    getBrands() {
      this.axios.get('api/dataGrabber/brands').then(resp => {
        if (resp.data) {
          this.brands = resp.data;
        }
      });
    },
    processSavedFilter() {
      if (this.filter.options.length) {
        this.selectedValues = _.map(this.filter.options, option => {
          return option.value;
        });
        let list = _.map(this.selectedValues, v => {
          let val = v.split('.&[')[1];
          val = val.substring(0, val.length - 1);
          val = val.split('.')[1];
          return val;
        });
        this.csv = list.join(',');

        let brand = this.selectedValues[0].split('.&[')[1];
        brand = brand.split('.')[0];
        brand = _.findKey(_brands(), v => {
          return v === brand;
        });
        this.brand = brand;
      }
    },
    loadFile(file) {
      if (file.name) {
        let regex = /^([a-z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
        if (!regex.test(file.name.toLowerCase())) {
          this.$bvToast(
            `Only xlsx and xls files are accepted. Please upload again.`,
            {
              title: 'File format',
              variant: 'warning',
              autoHideDelay: 5000,
              appendToast: true,
            }
          );
          return;
        }
        const reader = new FileReader();
        reader.onload = e => {
          let result = '';
          try {
            let buffer = e.target.result;
            let uint8Arr = new Uint8Array(buffer);
            let data = '';
            for (let i = 0; i < uint8Arr.byteLength; i++) {
              data += String.fromCharCode(uint8Arr[i]);
            }
            //Read the workbook as array
            let wb = XLSX.read(data, { type: 'binary' });
            let ws = wb.Sheets[wb.SheetNames[0]];
            let csv = XLSX.utils.sheet_to_csv(ws);
            let csvArr = csv.split('\n');
            csvArr = _.map(csvArr, row => {
              return row.split(',')[0];
            });
            result = csvArr.join(',');
          } catch (e) {
            this.$bvToast.toast(
              `Failed to process the uploaded file. Please try again.`,
              {
                title: 'Failed to load.',
                variant: 'warning',
                autoHideDelay: 5000,
                appendToast: true,
              }
            );
          }
          this.csv = result;
        };
        reader.readAsArrayBuffer(file);
      }
    },
    changed(selectedValues) {
      this.$emit(
        'input',
        _.map(selectedValues, option => {
          return { group: '-', text: '-', value: option };
        })
      );
    },
  },
};

function _brands() {
  return {
    F1: 'fun88',
    T1: 'tlc88',
    R1: 'rb88',
    P1: 'betway',
    J1: 'jbo',
    B1MX: 'B1MX',
    F1M5: 'F1M5',
  };
}
</script>

<style scoped></style>